<script setup lang="ts">
import {Checkbox, RadioButton} from "@/Components/Library";

const props = defineProps<{
    question: {[key: string]: any; options: any[]};
    disabled?: boolean;
}>();

const model = defineModel<Record<string, string[]>>();

const selectedCategories = (optionId: string): string[] => {
    return model.value[optionId] ?? [];
};

const setSelectedCategories = (optionId: string, categories: string[]): void => {
    if (categories.length) {
        model.value[optionId] = categories;
    } else {
        delete model.value[optionId];
    }
};

const setSelectedCategory = (optionId: string, category: string): void => {
    model.value[optionId] = [category];
};
</script>
<template>
    <div>
        <h3 class="mb-3 mt-1 px-1 text-sm font-bold">
            Select {{ question.params.allow_multiple ? "one or more categories" : "one category" }} for each option
        </h3>
        <div class="overflow-x-auto">
            <table class="w-full min-w-max border-collapse text-sm">
                <thead>
                    <tr>
                        <th scope="col" class="px-3 py-2 text-left font-bold">Options</th>
                        <th
                            v-for="category in question.categories"
                            :key="category.id"
                            scope="col"
                            class="px-3 py-2 text-center font-bold"
                        >
                            {{ category.name }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="option in question.options"
                        :key="option.id"
                        class="border-t border-stone-200 dark:border-stone-700"
                    >
                        <th scope="row" class="px-3 py-2 text-left font-medium">{{ option.value }}</th>
                        <template v-for="category in question.categories" :key="category.id">
                            <td class="px-3 py-2 text-center">
                                <Checkbox
                                    v-if="question.params.allow_multiple"
                                    :model-value="selectedCategories(option.id)"
                                    :value="category.id"
                                    :input-id="`matrix-${option.id}-${category.id}`"
                                    :name="`matrix-${option.id}`"
                                    :disabled="disabled"
                                    @update:model-value="setSelectedCategories(option.id, $event)"
                                />
                                <RadioButton
                                    v-else
                                    :model-value="selectedCategories(option.id)[0] ?? null"
                                    :value="category.id"
                                    :input-id="`matrix-${option.id}-${category.id}`"
                                    :name="`matrix-${option.id}`"
                                    :disabled="disabled"
                                    @update:model-value="setSelectedCategory(option.id, $event)"
                                />
                                <label :for="`matrix-${option.id}-${category.id}`" class="sr-only">
                                    {{ option.value }}: {{ category.name }}
                                </label>
                            </td>
                        </template>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<style scoped></style>
